// src/components/AdminRoute.js
// Updated: 08/24/2025 04:10 PM

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const AdminRoute = ({ children }) => {
  const { userProfile, isInitialized } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const isFullAdmin = userProfile?.role === 'Church Administrator' || userProfile?.role === 'Super Administrator';
  const canViewInquiries = userProfile?.canViewInquiries === true;
  const canSendNotifications = userProfile?.canSendNotifications === true;
  const canEditHomePage = userProfile?.canEditHomePage === true;

  // Allow access to the main dashboard if the user has ANY admin-level permission.
  if (location.pathname === '/admin') {
    if (isFullAdmin || canViewInquiries || canSendNotifications || canEditHomePage) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }

  // Specific check for the Send Push Notification page
  if (location.pathname === '/admin/send-notification') {
    if (isFullAdmin || canSendNotifications) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }

  // Special check for Email Settings: only full admins allowed.
  if (location.pathname === '/admin/email-settings') {
    if (isFullAdmin) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }

  // Check for the newsletter page
  if (location.pathname === '/admin/send-newsletter') {
    if (isFullAdmin || canSendNotifications) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }
  
  // Specific check for the Event Reminder Settings page
  if (location.pathname === '/admin/event-reminders') {
    if (isFullAdmin) {
      return children; // Only full admins can access this page
    } else {
      return <Navigate to="/" />;
    }
  }

  // Specific check for the inquiries page
  if (location.pathname === '/admin/inquiries') {
    if (isFullAdmin || canViewInquiries) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }

  // For all other admin routes (like User Management, Church Management), require full admin role
  if (isFullAdmin) {
    return children;
  }

  return <Navigate to="/" />;
};

export default AdminRoute;